import React from 'react'
import { NavLink } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'
import CircularProgress from '@material-ui/core/CircularProgress'

export default class ScriptStructure extends React.PureComponent {
  state = {
    activeSceneId: null,
    activeSlateId: null,
    activeTakeId: null
  }

  componentWillReceiveProps (nextProps) {
    const params = nextProps.history.location.pathname.replace('/script-log/write/', '').split('/')

    if (params[0] !== this.state.activeSceneId)
      this.setState({
        activeSceneId: params[0]
      })
    if (params[1] !== this.state.activeSlateId)
      this.setState({
        activeSlateId: params[1]
      })
    if (params[2] !== this.state.activeTakeId)
      this.setState({
        activeTakeId: params[2]
      })
  }

  handleAddNewSceneClick = () => {
    this.props.actions.fetchCreateScene()
  }

  handleAddNewSlateClick = sceneId => {
    this.props.actions.fetchCreateSlate(sceneId)
  }

  handleAddNewTakeClick = (sceneId, slateId) => {
    this.props.actions.fetchCreateTake(sceneId, slateId)
  }

  renderNavTree (tree, depth = 1) {
    const nextDepth = depth + 1
    return <ul className={depth === 1 ? 'nav-menu' : 'sub-menu'}>
      {tree.map((item, index) => {
        let className = ' '
        if (item.children && item.children.length)
          className += 'menu collapse-box '
        if (item.active)
          className += 'open '
        return <li key={index} className={className}>
          <NavLink to={item.url}
                   onClick={event => {
                     if (item.active) {
                       if (item.children) {
                         switch (item.type) {
                           case 'scene':
                             console.log(12)
                             this.setState({activeSceneId: null})
                             break
                           case 'slate':
                             this.setState({activeSlateId: null})
                             break
                           case 'take':
                             this.setState({activeTakeId: null})
                             break
                         }

                         console.log(this.state)
                       } else {
                         event.preventDefault()
                       }
                     }

                     if (item.onClick) {
                       event.preventDefault()
                       item.onClick()
                     }
                   }}
          >
            {item.indicator !== null && (item.indicator === true ? <div className="indicator active"/> : <div className="indicator"/>)}
            {item.text}
          </NavLink>
          {item.children && item.children.length && this.renderNavTree(item.children, nextDepth)}
        </li>
      })}
    </ul>
  }

  render () {
    const {template, script} = this.props
    const {scenes, slates, takes} = script

    const navTree = [
      ...scenes.allIds.slice().
        sort((a, b) => scenes.byId[a].sceneNumber > scenes.byId[b].sceneNumber).
        map(sceneId => ({
          type: 'scene',
          url: `/script-log/write/${sceneId}`,
          text: scenes.byId[sceneId].sceneName ? `${scenes.byId[sceneId].sceneNumber}. ${scenes.byId[sceneId].sceneName}` : `Scene ${scenes.byId[sceneId].sceneNumber}`,
          active: this.state.activeSceneId === sceneId,
          indicator: template.lists['scene'].showStatus ? scenes.byId[sceneId].complete : null,
          children: [
            ...scenes.byId[sceneId].slates.
              slice().sort((a, b) => slates.byId[a].slateNumber > slates.byId[b].slateNumber).
              map(slateId => ({
                type: 'slate',
                url: `/script-log/write/${sceneId}/${slateId}`,
                text: `Slate ${slates.byId[slateId].slateNumber}`,
                active: this.state.activeSlateId === slateId,
                indicator: template.lists['slate'].showStatus ? slates.byId[slateId].complete : null,
                children: [
                  ...slates.byId[slateId].takes.
                    slice().sort((a, b) => takes.byId[a].takeNumber > takes.byId[b].takeNumber).
                    map(takeId => ({
                      type: 'take',
                      url: `/script-log/write/${sceneId}/${slateId}/${takeId}`,
                      text: `Take ${takes.byId[takeId].takeNumber}`,
                      active: this.state.activeTakeId === takeId,
                      indicator: template.lists['take'].showStatus ? takes.byId[takeId].complete : null
                    })),
                  {
                    url: '#',
                    text: <div className="d-flex align-items-center">
                      <AddIcon className="mr-2"/>
                      Add new Take
                    </div>,
                    onClick: () => this.handleAddNewTakeClick(sceneId, slateId),
                    indicator: null
                  }
                ]
              })),
            {
              url: '#',
              text: <div className="d-flex align-items-center">
                <AddIcon className="mr-2"/>
                Add new Slate
              </div>,
              onClick: () => this.handleAddNewSlateClick(sceneId),
              indicator: null
            }
          ]
        })),
      {
        url: '#',
        text: <div className="d-flex align-items-center">
          <AddIcon className="mr-2"/>
          Add new Scene
        </div>,
        onClick: this.handleAddNewSceneClick,
        indicator: null
      }
    ]

    return <div className="side-nav script-structure">
      {this.renderNavTree(navTree)}
      {this.props.loading && <div className="d-flex justify-content-center">
        <CircularProgress className="m-2"/>
      </div>}
    </div>
  }
}


// WEBPACK FOOTER //
// ./components/ScriptStructure/index.js